import React from "react";
import { Link } from "react-router-dom";
import "./Blogs.css";
import blogPosts from "./blogData";

function Blogs() {
  return (
    <section className="blog-section">
      <h2>Our Sweet Stories</h2>
      <div className="blog-grid">
        {blogPosts.map((post) => (
          <Link to={`/blogs/${post.id}`} className="blog-card" key={post.id}>
            <div className="blog-title">{post.title}</div>
            <div className="blog-excerpt">{post.excerpt}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default Blogs;
